"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rdf = exports.value = exports.HTML = exports.type = exports.rest = exports.nil = exports.langString = exports.first = exports.List = exports.Property = exports._self = exports.ns = exports.loadData = void 0;
const JSONLD_1 = require("lincd-jsonld/lib/utils/JSONLD");
const NameSpace_1 = require("lincd/lib/utils/NameSpace");
const package_1 = require("../package");
const _this = __importStar(require("./rdf"));
var loadData = () => JSONLD_1.JSONLD.parsePromise(Promise.resolve().then(() => __importStar(require('../data/rdf.json'))));
exports.loadData = loadData;
exports.ns = (0, NameSpace_1.createNameSpace)('http://www.w3.org/1999/02/22-rdf-syntax-ns#');
exports._self = (0, exports.ns)('');
// Classes
exports.Property = (0, exports.ns)('Property');
exports.List = (0, exports.ns)('List');
// Properties etc.
exports.first = (0, exports.ns)('first');
exports.langString = (0, exports.ns)('langString');
exports.nil = (0, exports.ns)('nil');
exports.rest = (0, exports.ns)('rest');
exports.type = (0, exports.ns)('type');
exports.HTML = (0, exports.ns)('HTML');
exports.value = (0, exports.ns)('value');
exports.rdf = {
    List: exports.List,
    Property: exports.Property,
    first: exports.first,
    langString: exports.langString,
    nil: exports.nil,
    rest: exports.rest,
    type: exports.type,
    HTML: exports.HTML,
    value: exports.value,
};
(0, package_1.linkedOntology)(_this, exports.ns, 'rdf', exports.loadData, '../data/rdf.json');
//# sourceMappingURL=rdf.js.map